import { queryClient } from '@/lib/query-client'
import {
  clearStoredTenantDisplayName,
  clearStoredTenantSlug,
  clearStoredTenantUserId,
} from '@/lib/tenant'

export const TENANT_SUSPENDED_CODE = 'TENANT_SUSPENDED'

const WORKSPACES_PATH = '/workspaces'

export async function handleSuspendedTenantResponse(response: Response): Promise<void> {
  if (response.status !== 403) return

  const body: unknown = await response
    .clone()
    .json()
    .catch(() => null)
  const errorCode = (body as { error?: { code?: unknown } } | null)?.error?.code
  if (errorCode !== TENANT_SUSPENDED_CODE) return

  clearStoredTenantSlug()
  clearStoredTenantDisplayName()
  clearStoredTenantUserId()
  queryClient.clear()
  if (window.location.pathname !== WORKSPACES_PATH) {
    window.location.assign(WORKSPACES_PATH)
  }
}
